module.exports = "\n  \n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/getincar/getincar.component.html
// module id = ./src/app/getincar/getincar.component.html
// module chunks = main